import React, { useState, useEffect } from "react";
import {
  Button,
  Tooltip,
  IconButton,
  Grid,
  TextField,
  Box,
  Avatar,
  MenuItem,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  CircularProgress
} from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Card, Stack, Link, Container, Typography } from "@mui/material";
// layouts
// components
import Page from "../components/Page";
import { MHidden } from "../components/@material-extend";
import Logo from "../components/Logo";
import { LoginForm } from "../components/authentication/login";
import AuthSocial from "../components/authentication/AuthSocial";
import moment from "moment";
import { insertLead } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import { Routes } from "../constant/api_url";
import { Person } from "@mui/icons-material";
import { gender } from "src/constant/variable";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex"
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 556,
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "30px 0"
}));

const LoginFormCard = {
  padding: "15px",
  margin: "auto",
  display: "block"
};
const Login_body = {
  margin: "15px"
};
const form_title = {
  margin: "15px 0",
  textAlign: "center"
};
// ----------------------------------------------------------------------

export default function InquiryForm() {
  let date = moment().format("DD-MM-YYYY");
  const [isLoading, setIsLoading] = useState(false);

  const [formdata, setformdata] = useState({
    l_created_by: 27,
    l_type: 1, // 1 for offline public link inquiry
    l_allocated_to: 27,
    p_u_id: 0,
    date: date,
    l_phase: 1, // 1 for offline public link inquiry
    c_f: true
  });

  const [step, setStep] = useState(0);

  const submitformdata = async () => {
    if (
      formdata.gender == undefined ||
      formdata.gender == 0 ||
      formdata.name == undefined ||
      formdata.name == "" ||
      formdata.l_contact_no == undefined ||
      formdata.l_contact_no == "" ||
      formdata.l_email == undefined ||
      formdata.l_email == ""
    ) {
      let notify = notification({
        type: "error",
        message: "Please Fill Required Fields"
      });
      notify();
    } else {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formdata.l_email)) {
        notification({
          type: "error",
          message: "Please enter a valid email address"
        })();
        return;
      }

      setIsLoading(true);
      let resp = await insertLead(JSON.stringify(formdata));
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status == 1) {
        setStep(1);
        setformdata({
          l_created_by: 22,
          l_type: 1,
          l_allocated_to: 22,
          p_u_id: 0,
          date: date,
          l_phase: 1,
          gender: 0,
          name: "",
          l_business_name: "",
          l_contact_no: "",
          l_business_category: "",
          l_address: "",
          l_email: "",
          l_reference: ""
        });
      }
    }
  };

  const onChangeFunction = (e) => {
    setformdata({ ...formdata, [e.target.name]: e.target.value });
  };
  return (
    <Page title="Prime Member Offline Inquiry Form | Local Vocal Business Group">
      <Container>
        <ContentStyle>
          <Card className="LoginFormCard" style={LoginFormCard}>
            {step === 0 ? (
              <>
                {" "}
                <Box
                  component="img"
                  // src="/static/logolvb.png"
                  src={Routes.API_HOSTNAME + "logo/LVB-PRIME-LOGO.png"}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/static/logo/LVB-PRIME-LOGO.png";
                  }}
                  sx={{ display: "block", margin: "auto", height: "100px" }}
                />
                {/* <Logo /> */}
                <h4 className="form_title" style={form_title}>
                  PRIME MEMBER OFFLINE INQUIRY FORM
                </h4>
                <Box
                  sx={{
                    // backgroundColor: "#fff8e1",
                    // border: "1px solid #ffecb3",
                    // borderRadius: "8px",
                    padding: "16px",
                    margin: "15px 20px",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", display: "flex", alignItems: "center", mb: 1 }}
                  >
                    <span role="img" aria-label="loudspeaker" style={{ marginRight: 8 }}>
                      📢
                    </span>
                    Important Notice for Offline Membership Applicants
                  </Typography>

                  <Typography variant="body2" sx={{ color: "#5d4037", lineHeight: 1.6 }}>
                    While applying for <b>offline membership</b>, please note that:
                    <br />
                    <br />• The <b>Welcome Kit option is not available</b> in offline mode.
                    <br />• This membership is <b>only for selected business persons</b>.
                    <br />• You <b>must mention a valid reference name</b> to ensure your
                    application is <b>processed quickly</b>.
                    <br />
                    <br />
                    Please follow the above points carefully to avoid any delay in approval.
                  </Typography>
                </Box>
                <div className="Login_body" style={Login_body}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Gender *</FormLabel>

                          <RadioGroup
                            name="gender"
                            row // remove this if you want vertical
                            value={formdata?.gender || ""}
                            onChange={onChangeFunction}
                          >
                            {gender
                              .filter((g) => g.value !== 0) // remove "Select Gender"
                              .map((g) => (
                                <FormControlLabel
                                  key={g.value}
                                  value={g.value}
                                  control={<Radio />}
                                  label={g.label}
                                />
                              ))}
                          </RadioGroup>
                        </FormControl>
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Name *"
                          name="name"
                          value={formdata?.name}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Contact Number *"
                          name="l_contact_no"
                          value={formdata?.l_contact_no}
                          inputProps={{ maxLength: 10 }}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");

                            onChangeFunction({
                              target: {
                                name: e.target.name,
                                value: value
                              }
                            });
                          }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Email Id *"
                          name="l_email"
                          value={formdata?.l_email}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Address"
                          name="l_address"
                          value={formdata?.l_address}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Name"
                          name="l_business_name"
                          value={formdata?.l_business_name}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Business Category"
                          name="l_business_category"
                          value={formdata?.l_business_category}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={12}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          autoComplete="off"
                          type="text"
                          label="Reference"
                          name="l_reference"
                          value={formdata?.l_reference}
                          onChange={onChangeFunction}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </div>
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center"
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={submitformdata}
                    disabled={isLoading}
                    startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                  >
                    Submit
                  </Button>
                </div>{" "}
              </>
            ) : (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center"
                  }}
                >
                  <Box
                    component="img"
                    // src="/static/logolvb.png"
                    src={Routes.API_HOSTNAME + "logo/LVB-PRIME-LOGO.png"}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/static/logo/LVB-PRIME-LOGO.png";
                    }}
                    sx={{ display: "block", margin: "auto", height: "100px" }}
                  />
                  <Avatar
                    sx={{
                      bgcolor: "primary.main",
                      width: 56,
                      height: 56,
                      mb: 2,
                      mt: 3
                    }}
                  >
                    <Person sx={{ fontSize: 32 }} />
                  </Avatar>
                  <Typography variant="h5" gutterBottom color="primary">
                    Data Inserted Successfully!
                  </Typography>
                </Box>
                <Box
                  sx={{
                    // backgroundColor: "#fff8e1",
                    // border: "1px solid #ffecb3",
                    // borderRadius: "8px",
                    padding: "16px",
                    margin: "15px 20px",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", display: "flex", alignItems: "center", mb: 1 }}
                  >
                    <span role="img" aria-label="loudspeaker" style={{ marginRight: 8 }}>
                      📢
                    </span>
                    Important Notice for Offline Membership Applicants
                  </Typography>

                  <Typography variant="body2" sx={{ color: "#5d4037", lineHeight: 1.6 }}>
                    While applying for <b>offline membership</b>, please note that:
                    <br />
                    <br />• The <b>Welcome Kit option is not available</b> in offline mode.
                    <br />• This membership is <b>only for selected business persons</b>.
                    <br />• You <b>must mention a valid reference name</b> to ensure your
                    application is <b>processed quickly</b>.
                    <br />
                    <br />
                    Please follow the above points carefully to avoid any delay in approval.
                  </Typography>
                </Box>
              </>
            )}
          </Card>
        </ContentStyle>
      </Container>
    </Page>
  );
}
